import type { Message as ChatMessage } from '@/chat/types';
import { AssistantBubble } from './assistant-bubble';
import { UserBubble } from './user-bubble';

interface MessageBubbleProps {
  message: ChatMessage;
}

export const MessageBubble = ({ message }: MessageBubbleProps) =>
  message.role === 'user' ? (
    <UserBubble message={message} />
  ) : (
    <AssistantBubble message={message} />
  );
